/**
 * 个股行情顶部盘口-更多按钮
 */
import React from "react"
import { loadmore } from "../utils"

export function LoadMore() {
  return (
    <p>
      <span>&nbsp;</span>
      <a
        href="#"
        className="btn-more"
        onClick={(e) => {
          e.preventDefault()
          loadmore()
        }}
      >
        更多
      </a>
    </p>
  )
}

export function RelevantLoadMore(props: { loadMore: Function }) {
  return (
    <div className="stockmore-loadmore" onClick={() => props.loadMore()}>
      查看更多
      <i className="arrow-down"></i>
    </div>
  )
}

export function BondLoadMore() {
  return (
    <div
      className="bond-more"
      onClick={(e) => {
        e.preventDefault()
        loadmore()
      }}
    >
      <i className="bond-more-button"></i>
    </div>
  )
}
